// Keep paired short-card cut lines identical after real fonts and images load.
// Long bilingual cards use explicitly curated front/back content, never scaling
// the entire prayer to an unreadably small size or silently discarding words.
export const printCardLayoutScript = `<script>
(() => {
  const fit = () => {
    if (!document.body.classList.contains('as-cards')) return;
    const cards = [...document.querySelectorAll('.card.holy')];
    if (!document.body.matches('.compact,.duplex-content')) {
      cards.forEach(c => c.style.height = '');
      const height = Math.ceil(Math.max(...cards.map(c => c.getBoundingClientRect().height)));
      cards.forEach(c => c.style.height = height + 'px');
    }
    document.body.dataset.printReady = 'true';
  };
  Promise.all([document.fonts.ready, ...[...document.images].map(i => i.complete ? Promise.resolve() : new Promise(r => { i.addEventListener('load', r, {once:true}); i.addEventListener('error', r, {once:true}); }))]).then(fit);
  window.addEventListener('beforeprint', fit);
})();
</script>`;